const updates = [
  {
    date: '2026-07-31',
    title: '「星际迷航：新纪元」4K修复版上线',
    desc: '科幻经典迎来4K超清修复，新增导演评论音轨与幕后花絮独家内容',
    tag: '新片上线',
    tagColor: 'primary',
  },
  {
    date: '2026-07-30',
    title: '暑期观影节专题页面上线',
    desc: '精选50部暑期必看大片，每日推荐一部高分冷门佳作',
    tag: '活动',
    tagColor: 'accent',
  },
  {
    date: '2026-07-29',
    title: '移动端播放引擎全面升级',
    desc: '优化移动网络下的自适应码率切换策略，4G环境下也能流畅播放1080P内容',
    tag: '技术',
    tagColor: 'secondary',
  },
  {
    date: '2026-07-28',
    title: '「长安十二时辰」全集超清上线',
    desc: '古装悬疑口碑神剧完整48集一次性放出，支持离线缓存观看',
    tag: '新片上线',
    tagColor: 'primary',
  },
  {
    date: '2026-07-27',
    title: '纪录片频道内容扩充至1960部',
    desc: 'BBC、国家地理、Discovery等顶级厂牌纪录片持续引进中',
    tag: '内容',
    tagColor: 'accent',
  },
  {
    date: '2026-07-26',
    title: '用户播放数据看板功能上线',
    desc: '个人观影统计、类型偏好分析与个性化推荐算法全面优化',
    tag: '功能',
    tagColor: 'primary',
  },
  {
    date: '2026-07-25',
    title: '华语经典修复计划启动',
    desc: '首批20部上世纪经典港片进入AI修复流程，预计8月中旬陆续上线',
    tag: '企划',
    tagColor: 'accent',
  },
  {
    date: '2026-07-24',
    title: '多语言字幕功能开放测试',
    desc: '首批支持中、英、日、韩四种语言字幕，更多语种持续添加中',
    tag: '功能',
    tagColor: 'primary',
  },
  {
    date: '2026-07-23',
    title: 'CDN节点扩容至全球30个区域',
    desc: '大幅提升海外用户访问速度，亚洲地区延迟降低至50ms以内',
    tag: '技术',
    tagColor: 'secondary',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            平台动态
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            最新动态
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            关注酷客影院的最新内容上线、功能更新与技术升级
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200">
            {updates.map((item, i) => (
              <div key={i} className="relative pb-8 last:pb-0">
                <div className={`absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full border-2 border-background-50 ${
                  item.tagColor === 'primary' ? 'bg-primary-500' :
                  item.tagColor === 'accent' ? 'bg-accent-500' : 'bg-secondary-500'
                }`} />
                <div className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60">
                  <div className="flex items-center gap-2 flex-wrap mb-2">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className={`px-2 py-0.5 text-[10px] font-medium rounded whitespace-nowrap ${
                      item.tagColor === 'primary' ? 'bg-primary-100 text-primary-700' :
                      item.tagColor === 'accent' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}